// @flow

import React, { Component } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route } from 'react-router-dom';
import { matchRoutes } from 'react-router-config';

import { handleDataDependencies } from '../../lib/ssr/fetch-data';

type Location = {
  pathname: string,
  search: string,
  hash: string
};

type Routes = Array<mixed>;

type Props = {
  children: Node,
  location: Location,
  routes: Routes
};

type State = {
  previousLocation: Location | null
};

type Context = {
  store: Object
};

class PendingNavDataLoader extends Component<Props, State> {
  static contextTypes = {
    store: PropTypes.object.isRequired
  };

  constructor(props: Props, context: Context) {
    super(props);

    this.fetchData(props, context);

    this.state = {
      previousLocation: null
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    const navigated = nextProps.location !== this.props.location;
    if (navigated) {
      // save the location so we can render the old screen
      this.setState({
        previousLocation: this.props.location
      });

      this.fetchData(nextProps);
    }
  }

  async fetchData(
    props: Props,
    context: Context = this.context,
    reload?: boolean
  ) {
    const store = context.store;
    const location = props.location;
    const url = location.pathname; // + location.search + location.hash;
    const routes = matchRoutes(props.routes, url);

    await handleDataDependencies({
      location,
      store,
      routes,
      deferred: false,
      reload
    });

    this.setState({ previousLocation: null });

    handleDataDependencies({
      location,
      store,
      routes,
      deferred: true,
      reload
    });
  }

  render() {
    const { children, location } = this.props;
    const { previousLocation } = this.state;

    return (
      <Route location={previousLocation || location} render={() => children} />
    );
  }
}

export default withRouter(PendingNavDataLoader);
